import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-content-center" }
const _hoisted_2 = {
  id: "document",
  class: "d-inline-block"
}
const _hoisted_3 = { class: "flex justify-content-end mt-3" }
const _hoisted_4 = {
  key: 0,
  class: "mr-2 text-left"
}
const _hoisted_5 = {
  key: 0,
  class: "mr-2 align-self-end",
  style: {"width":"120px"}
}
const _hoisted_6 = { class: "p-input-icon-right" }
const _hoisted_7 = { class: "align-self-end" }
const _hoisted_8 = {
  key: 2,
  class: "align-self-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_EmailTemplate = _resolveComponent("EmailTemplate")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid",
    style: {"min-width":"60%","width":"1780px","max-width":"95%","height":"95%"},
    position: 'center',
    header: _ctx.getPopupHeader,
    showHeader: true,
    modal: true,
    maximizable: true,
    visible: _ctx.show,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.show) = $event))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showIssuedDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "Issue Date", -1)),
              _createVNode(_component_Calendar, {
                modelValue: _ctx.issuedDate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.issuedDate) = $event)),
                dateFormat: "d MM yy",
                showButtonBar: true,
                placeholder: "Issue Date"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDocumentPanel && _ctx.activeTab==0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.useAutoScale)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.documentScaling,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.documentScaling) = $event)),
                        type: "number",
                        class: "text-right"
                      }, null, 8, ["modelValue"]),
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-percentage" }, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Button, {
                  label: (_ctx.isGeneratingDocument? 'Generating...' : 'Generate'),
                  onClick: _ctx.generateDocument,
                  disabled: _ctx.isGeneratingDocument || _ctx.isEmailSendingDisabled,
                  class: _normalizeClass(_ctx.isEmailSendingDisabled ? 'disabled-feature':'')
                }, null, 8, ["label", "onClick", "disabled", "class"])
              ])
            ], 64))
          : (_ctx.showEmailPanel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  label: (_ctx.isEmailSending? 'Sending...' : 'Send Email'),
                  onClick: _ctx.onSendEmailClick,
                  disabled: _ctx.wasEmailSent || _ctx.isEmailTemplateLoading || _ctx.isEmailSendingDisabled,
                  class: _normalizeClass(_ctx.isEmailSendingDisabled ? 'disabled-feature':'')
                }, null, 8, ["label", "onClick", "disabled", "class"])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TabView, {
        activeIndex: _ctx.activeTab,
        "onUpdate:activeIndex": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          (_ctx.showDocumentPanel)
            ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                header: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "pi pi-file-pdf" }, null, -1),
                  _createTextVNode("  ", -1),
                  _createElementVNode("span", null, "Document", -1)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.document.templateName), {
                        propertyData: _ctx.propertyData,
                        reportContact: _ctx.reportContact,
                        service: _ctx.toggledService,
                        issuedDate: _ctx.issuedDate,
                        onUpdateServicesCount: _cache[0] || (_cache[0] = ($event: any) => {_ctx.servicesCount = $event;}),
                        onUpdateDateOfEvacuation: _cache[1] || (_cache[1] = ($event: any) => {_ctx.dateOfEvacuation = $event;})
                      }, null, 40, ["propertyData", "reportContact", "service", "issuedDate"]))
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showEmailPanel)
            ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                header: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "pi pi-envelope" }, null, -1),
                  _createTextVNode("  ", -1),
                  _createElementVNode("span", null, "Email", -1)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_EmailTemplate, {
                      ref: "EmailTemplate",
                      propertyData: _ctx.propertyData,
                      recipientCompanyId: _ctx.recipientCompanyId,
                      emailTemplateType: _ctx.selectedEmailTemplate,
                      service: _ctx.toggledService,
                      issuedDate: _ctx.issuedDate,
                      onUpdateIsEmailSending: _cache[2] || (_cache[2] = ($event: any) => {_ctx.isEmailSending = $event;}),
                      onUpdateWasEmailSent: _cache[3] || (_cache[3] = ($event: any) => {_ctx.wasEmailSent = $event;}),
                      onUpdateIsEmailTemplateLoading: _cache[4] || (_cache[4] = ($event: any) => {_ctx.isEmailTemplateLoading = $event;}),
                      onReloadData: _ctx.reloadData,
                      onUpdateShow: _cache[5] || (_cache[5] = ($event: any) => {_ctx.show = $event;})
                    }, null, 8, ["propertyData", "recipientCompanyId", "emailTemplateType", "service", "issuedDate", "onReloadData"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}